// Local cache utility for fast data loading
const CACHE_PREFIX = 'knowroom-cache-';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export const cache = {
  set(key, data, userId = null) {
    const cacheKey = userId ? `${CACHE_PREFIX}${userId}-${key}` : `${CACHE_PREFIX}${key}`;
    try {
      localStorage.setItem(cacheKey, JSON.stringify({
        data,
        timestamp: Date.now()
      }));
    } catch (e) {
      // localStorage might be full or disabled
      console.warn('Cache write failed:', e);
    }
  },

  get(key, userId = null) {
    const cacheKey = userId ? `${CACHE_PREFIX}${userId}-${key}` : `${CACHE_PREFIX}${key}`;
    try {
      const cached = localStorage.getItem(cacheKey);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);

      // Return data even if stale - we'll refresh in background
      return {
        data,
        isStale: Date.now() - timestamp > CACHE_TTL
      };
    } catch (e) {
      return null;
    }
  },

  clear(key, userId = null) {
    const cacheKey = userId ? `${CACHE_PREFIX}${userId}-${key}` : `${CACHE_PREFIX}${key}`;
    try {
      localStorage.removeItem(cacheKey);
    } catch (e) {
      // ignore
    }
  },

  clearAll(userId = null) {
    try {
      const prefix = userId ? `${CACHE_PREFIX}${userId}-` : CACHE_PREFIX;
      Object.keys(localStorage)
        .filter(k => k.startsWith(prefix))
        .forEach(k => localStorage.removeItem(k));
    } catch (e) {
      // ignore
    }
  }
};
